import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const search = (body) => {
    return vdkEmHappinessPortalApi.post('/global-search/search', body);
};
const globalSearchAPI = { search };
export default globalSearchAPI;
